import { string } from 'yup'
import { safify } from '../utils/safify'

export const captionType = string()
  .meta({ label: 'What do you need a caption for?' })
  .oneOf(['post', 'story', 'reel'])
  .default('post')
  .transform(safify)
